import React, { Component } from 'react';
import { ApLoaderDefault } from '@alixpartners/ui-components';

import { Checkbox } from 'components/CheckboxGroup';
import { StepWrapper } from '../styles';
import {
	ButtonMain,
	StepFooter,
	CheckboxGroup,
	ColumnTitle,
	ColumnItem,
	Row,
	LoaderContainer,
	LoaderText,
	SectionSubtitle,
} from './styles';

export default class ConfigureClassificationStep extends Component {
	onChange = e => {
		const { onChange, data } = this.props;
		const { name: clickedColumnName, checked: isSelected } = e.target;
		const updatedColumns = data.map(item => {
			if (item.name === clickedColumnName) {
				return { ...item, isSelected };
			}

			return item;
		});

		onChange({ columns: updatedColumns });
	};

	render() {
		const { onSubmit, loading, data } = this.props;

		if (loading) {
			return (
				<StepWrapper>
					<LoaderContainer>
						<ApLoaderDefault loaderText={() => <LoaderText />} />
					</LoaderContainer>
				</StepWrapper>
			);
		}

		return (
			<StepWrapper>
				<SectionSubtitle>
					Select columns that can be used to help classify the data. Note - if
					you select columns that contain poor or irrelevant data, the results
					of the classification are likely to be skewed.
				</SectionSubtitle>
				<ClassificationColumns onChange={this.onChange} data={data} />
				<StepFooter>
					<ButtonMain onClick={onSubmit}>Continue</ButtonMain>
				</StepFooter>
			</StepWrapper>
		);
	}
}

export const ClassificationColumns = ({ onChange, data }) => (
	<CheckboxGroup>
		<Row>
			<ColumnTitle>Column name</ColumnTitle>
			<ColumnTitle>Columns values</ColumnTitle>
		</Row>
		{data.map(({ name, labels, isSelected }) => (
			<Row key={name}>
				<ColumnItem>
					<Checkbox onChange={onChange} name={name} checked={isSelected}>
						{name}
					</Checkbox>
				</ColumnItem>
				<ColumnItem>
					{labels && labels.filter(value => value).join(', ')}
				</ColumnItem>
			</Row>
		))}
	</CheckboxGroup>
);
